import { __rest } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import clsx from 'clsx';
import { AutoComplete as AutoComplete$1 } from 'primereact/autocomplete';
import { Tooltip } from 'primereact/tooltip';
import { forwardRef, useState, useEffect } from 'react';
import { useFormContext, useWatch, Controller } from 'react-hook-form';
import { getPlaceholder } from '../../_utils/get-placeholder.js';
import { InputWrapper } from '../InputWrapper/InputWrapper.js';

function NewPillComponent(_ref) {
  let {
    hasNewValue
  } = _ref;
  if (!hasNewValue) {
    return null;
  }
  return jsxs(Fragment, {
    children: [jsx(Tooltip, {
      target: "#new-pill",
      content: "New value",
      position: "top"
    }), jsx("span", {
      id: "new-pill",
      className: "autocomplete-new-value"
    })]
  });
}
function AutoCompleteComponent(props, ref) {
  const {
      name,
      value,
      labelClassName,
      horizontal,
      forceSelection,
      onBlur: _,
      wrapperClassName: ___,
      errorClassName: ____,
      prefixIcon: ________,
      placeholder: _______,
      bulkMode: _________
    } = props,
    restProps = __rest(props, ["name", "value", "labelClassName", "horizontal", "forceSelection", "onBlur", "wrapperClassName", "errorClassName", "prefixIcon", "placeholder", "bulkMode"]);
  const placeholder = getPlaceholder(props);
  const [inputHasNewValue, setInputHasNewValue] = useState(false);
  const formContext = useFormContext();
  const isControlled = typeof value !== 'undefined';
  const prefixIconTemplate = props.prefixIcon ? jsx("span", {
    className: "p-inputgroup-addon",
    children: props.prefixIcon
  }) : null;
  const controlValue = useWatch({
    control: formContext.control,
    name: name !== null && name !== void 0 ? name : ''
  });
  useEffect(() => {
    if (!props) {
      return;
    }
    const {
      name,
      suggestions,
      minLength
    } = props;
    if (!suggestions || !name) {
      return;
    }
    if (!controlValue) {
      setInputHasNewValue(false);
      return;
    }
    if (minLength && (controlValue === null || controlValue === void 0 ? void 0 : controlValue.length) < minLength) {
      setInputHasNewValue(false);
    } else {
      const foundOption = suggestions === null || suggestions === void 0 ? void 0 : suggestions.find(s => {
        if (Object.hasOwn(s, 'value')) {
          return (s === null || s === void 0 ? void 0 : s.value) === (controlValue === null || controlValue === void 0 ? void 0 : controlValue.value);
        }
        return s === controlValue;
      });
      setInputHasNewValue(!foundOption && controlValue !== '');
    }
  }, [props.suggestions, controlValue, props]);
  const [searchTerm, setSearchTerm] = useState(undefined);
  const wrapperProps = __rest(props, ["field", "prefixIcon"]);
  if (isControlled || !formContext || !name) {
    const autoCompleteProps = __rest(props, ["wrapperClassName", "labelClassName", "labelTooltip", "errorClassName"]);
    return jsx(InputWrapper, Object.assign({}, wrapperProps, {
      children: jsxs("div", {
        className: "autocomplete-wrapper p-inputgroup flex-1",
        children: [prefixIconTemplate, jsx(AutoComplete$1, Object.assign({
          className: "flex grow",
          ref: ref
        }, autoCompleteProps, {
          placeholder: placeholder
        })), jsx(NewPillComponent, {
          hasNewValue: inputHasNewValue
        })]
      })
    }));
  }
  return jsx(Controller, {
    name: name,
    control: formContext.control,
    rules: {
      required: props.required && !props.bulkMode,
      minLength: props.minLength
    },
    render: _ref2 => {
      let {
        field,
        fieldState
      } = _ref2;
      return jsx(InputWrapper, Object.assign({
        fieldState: fieldState,
        horizontal: horizontal,
        labelClassName: labelClassName
      }, wrapperProps, {
        field: field,
        children: jsxs("div", {
          className: "autocomplete-wrapper p-inputgroup flex-1",
          children: [prefixIconTemplate, jsx(AutoComplete$1, Object.assign({}, restProps, {
            className: clsx('flex grow overflow-hidden', (fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid) ? 'p-invalid' : null),
            value: searchTerm !== null && searchTerm !== void 0 ? searchTerm : field.value,
            onChange: e => {
              // if forceSelection is false, we allow free text input
              if (!forceSelection) {
                field.onChange(e.value);
              } else {
                setSearchTerm(e.value);
              }
            },
            onSelect: e => {
              setSearchTerm(undefined);
              field.onChange(e.value);
            },
            ref: ref,
            placeholder: placeholder
          })), jsx(NewPillComponent, {
            hasNewValue: inputHasNewValue
          })]
        })
      }));
    }
  });
}
const AutoComplete = /*#__PURE__*/forwardRef(AutoCompleteComponent);

export { AutoComplete };
